import { render, staticRenderFns } from "./Layout_V2.vue?vue&type=template&id=6ed39c52&scoped=true"
import script from "./Layout_V2.vue?vue&type=script&lang=js"
export * from "./Layout_V2.vue?vue&type=script&lang=js"
import style0 from "./Layout_V2.vue?vue&type=style&index=0&id=6ed39c52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed39c52",
  null
  
)

export default component.exports